var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.973,
    height: 8.079,
    viewBox: "0 0 12.973 8.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8161.999 4091.539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.327,7.871h-8.8a2,2,0,0,1-2-2v-3a2,2,0,0,1,2-2h8.8a2,2,0,0,1,2,2v3A2,2,0,0,1,7.327,7.871ZM.6,2.243A2,2,0,0,0-1.349,4.47,1.972,1.972,0,0,0,.6,6.534a.568.568,0,0,0,.058,0,1.593,1.593,0,0,0,1.257-.609l.143.511H2.4V4.281H.609V4.74H1.917a1.285,1.285,0,0,1-.333.954A1.319,1.319,0,0,1,.6,6.077,1.478,1.478,0,0,1-.8,4.441C-.8,3.639-.434,2.7.6,2.7a1.1,1.1,0,0,1,1.216.9h.545A1.584,1.584,0,0,0,.6,2.243Zm4.09.1v4.1h.545V4.562h1.88V4.1H5.238V2.8H7.382V2.342Zm-1.464,0v4.1h.545v-4.1Z",
    transform: "translate(8165.472 -4091.87)",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19317.07 -12709.539)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11155 8618)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.998 1.855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.3,331.989a2.008,2.008,0,0,1-.844-.178,1.876,1.876,0,0,1-.632-.474,2.1,2.1,0,0,1-.395-.678,2.338,2.338,0,0,1-.136-.792,2.944,2.944,0,0,1,.125-.868,2.191,2.191,0,0,1,.377-.728,1.855,1.855,0,0,1,1.506-.687,2.014,2.014,0,0,1,1.191.331,1.567,1.567,0,0,1,.626,1.076l.011.066h-.659l-.008-.047a1.049,1.049,0,0,0-1.16-.854c-1,0-1.349.906-1.349,1.682a1.424,1.424,0,0,0,1.349,1.578,1.26,1.26,0,0,0,.939-.366,1.207,1.207,0,0,0,.318-.856h-1.253l0-.057h-.054v-.516h1.91v2.271h-.445l-.125-.446a1.488,1.488,0,0,1-.547.4A1.893,1.893,0,0,1,356.3,331.989Zm0-4.291a2.1,2.1,0,0,0,0,4.177,1.535,1.535,0,0,0,1.267-.585l.069-.094.163.582h.244v-2.043h-1.682v.345h1.305l0,.054a1.331,1.331,0,0,1-.348.995,1.242,1.242,0,0,1-.439.294,1.557,1.557,0,0,1-.583.107,1.338,1.338,0,0,1-1.09-.518,1.9,1.9,0,0,1-.373-1.173,2.165,2.165,0,0,1,.341-1.231,1.3,1.3,0,0,1,.457-.41,1.406,1.406,0,0,1,.665-.155,1.45,1.45,0,0,1,.828.228,1.022,1.022,0,0,1,.286.3,1.147,1.147,0,0,1,.149.375h.43A1.532,1.532,0,0,0,356.3,327.7Z",
    transform: "translate(-354.292 -327.582)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.96,328.85h.659v4.21h-.659Zm.545.114h-.432v3.982h.431Z",
    transform: "translate(-408.382 -328.75)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.369,333.059h-.659v-4.21h2.8v.573h-2.145v1.188h1.881v.573h-1.881Zm-.545-.114h.431v-1.876h1.881v-.345h-1.881v-1.416H434.4v-.345h-2.576Z",
    transform: "translate(-425.67 -328.749)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.929.6A1.326,1.326,0,0,0,.6,1.929v4.22A1.326,1.326,0,0,0,1.929,7.476h9.043A1.326,1.326,0,0,0,12.3,6.149V1.929A1.326,1.326,0,0,0,10.972.6H1.929m0-.6h9.043A1.929,1.929,0,0,1,12.9,1.929v4.22a1.929,1.929,0,0,1-1.929,1.929H1.929A1.929,1.929,0,0,1,0,6.149V1.929A1.929,1.929,0,0,1,1.929,0Z",
    transform: "translate(0 0)",
    fill: "#959595"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.5346fa58034300f01cb17b5dd9a86163.svg";
export { ForwardRef as ReactComponent };